module.exports = __webpack_public_path__ + "images/arr-up-green.svg?0bff99db80241cc1d7dbd44fc3e440a4";